import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { NeuroConstants } from '../store/neuro.constants'
import {
  saveMotorSensory,
  setMotorSensory,
  setMotorSensoryState,
} from '../motorSensoryAssessment/store/motoSensoryAssessment.actions'
import { IMotorSensoryAssessmentState } from '../motorSensoryAssessment/store/motoSensoryAssessment.types'
import { getMotorSensoryAssessmentSelector } from '../motorSensoryAssessment/selectors'
import { INeuroState } from '../store/neuro.types'
import { getNeuroSelector } from '../selectors'
import { IDataPointsConfig } from '../../../configurations/store/configurations.types'
import { getDatapointsConfigSelector } from '../../../configurations/selectors'

export function* setMotorSensoryViaChemParalyzed() {
  const motorSensoryAssessment: IMotorSensoryAssessmentState = yield select(getMotorSensoryAssessmentSelector)
  const neuro: INeuroState = yield select(getNeuroSelector)
  const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
  const { DP_MOTOR_PICKLIST, DP_SENSORY_PICKLIST } = datapointsConfig

  const chemParalyzedFlag: boolean = neuro.chemParalyzed === 1
  try {
    if (chemParalyzedFlag) {
      yield put(setMotorSensoryState(motorSensoryAssessment))
      const updatedMotorSensoryAssessment: IMotorSensoryAssessmentState = yield select(
        getMotorSensoryAssessmentSelector
      )

      if (DP_MOTOR_PICKLIST) {
        updatedMotorSensoryAssessment.motorLa = { id: 4, name: 'Chemically Paralyzed' }
        updatedMotorSensoryAssessment.motorLl = { id: 4, name: 'Chemically Paralyzed' }
        updatedMotorSensoryAssessment.motorRa = { id: 4, name: 'Chemically Paralyzed' }
        updatedMotorSensoryAssessment.motorRl = { id: 4, name: 'Chemically Paralyzed' }
      }

      if (DP_SENSORY_PICKLIST) {
        updatedMotorSensoryAssessment.sensoryLa = { id: 5, name: 'Unable to assess' }
        updatedMotorSensoryAssessment.sensoryLl = { id: 5, name: 'Unable to assess' }
        updatedMotorSensoryAssessment.sensoryRa = { id: 5, name: 'Unable to assess' }
        updatedMotorSensoryAssessment.sensoryRl = { id: 5, name: 'Unable to assess' }
      }

      yield put(setMotorSensory(updatedMotorSensoryAssessment))
    } else {
      const { motorComments, headSensory } = motorSensoryAssessment
      const motorSensoryPrevState = { ...motorSensoryAssessment?.motorSensoryState, motorComments, headSensory }
      yield put(setMotorSensory(motorSensoryPrevState))
    }

    yield put(saveMotorSensory())
  } catch (e) {
    yield put(throwPcrException(`setMotorSensoryViaChemParalyzed() error: ${e}`))
  }
}

export function* setMotorSensoryViaChemParalyzedSaga() {
  yield takeLatest([NeuroConstants.SET_MOTOR_SENSORY_VIA_CHEMPARALYZED], setMotorSensoryViaChemParalyzed)
}
